import { api } from 'lib/httpClient';

export const getDeploymentUpdate = (id) => {
  return () => {
    return api
      .get(`deployment-update/${id}`)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response.data.data.deploymentUpdate);
        }
      })
      .catch((error) => {
        return Promise.resolve(error);
      });
  };
};
